<template>
  <ul class="collapsible popout">
    <li class="collapsible-margin">
      <div class="collapsible-header">
        <i class="material-icons">lightbulb</i> Innovate
        <i class="material-icons">expand_more</i>
      </div>
      <div class="collapsible-body tech row">
        First, place all the cards in your hand in your discard pile.<br /><br />
        Then, break through for any uncivilized, civilized, region, or tributary, as described on page 15.<br /><br />
        Then move on to clean up. <br /><br />
        <b> You cannot take actions or use exhaust abilities if you innovate</b>
      </div>
    </li>
    <li class="collapsible-margin">
      <div class="collapsible-header">
        <i class="material-icons">whatshot</i> Revolt
        <i class="material-icons">expand_more</i>
      </div>
      <div class="collapsible-body tech row">
        Return any number of unrest cards from your hand to the unrest pile.<br /><br />
        Then move on to clean up.<br /><br />
        <b> You cannot take actions or use exhaust abilities if you revolt.</b>
      </div>
    </li>
    <li class="collapsible-margin active" id="activate">
      <div class="collapsible-header">
        <i class="material-icons">style</i>Activate
      </div>
      <div class="collapsible-body tech row">
        <div class="col s12">
          <div class="col s4">
            <button
              @click="actions--"
              class="waves-effect waves-light btn col s12"
            >
              -
            </button>
          </div>
          <div class="col s4">{{ actions }} Actions</div>
          <div class="col s4">
            <button
              @click="actions++"
              class="waves-effect waves-light btn col s12"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  setup() {
    onMounted(() => {
      var elems = document.querySelectorAll(".collapsible");
      window.M.Collapsible.init(elems, {});
    });
    const actions = ref(3);
    return {
      actions,
    };
  },
});
</script>

<style></style>
